<template>
  <confirmation-dialog
    visible
    :title="$t('title.upgrade')"
    :confirm-title="isVIP ? $t('button.ok') : $t('button.view_upgrade_options')"
    :hide-cancel="isVIP"
    @confirm="isVIP ? emit('close') : upgradePlanAction()"
    @close="emit('close')"
  >
    <p class="pb-1 mb-0">
      {{ $t('message.feature_not_available_in_current_plan') }}
    </p>
    <p
      v-if="isVIP"
      class="py-1 mb-0"
    >
      {{ $t('message.talk_to_sales_to_upgrade') }}
    </p>
    <i18n
      v-else
      path="message.feature_upgrade_to_plan"
      tag="span"
    >
      <span class="font-weight-bold">{{ message }}</span>
    </i18n>
  </confirmation-dialog>
</template>

<script setup lang="ts">

import { BillingInfoSubscriptionStatus } from '@/model/Account';
import store from '@/store/store';
import { computed, PropType } from 'vue';
import { useRouter } from 'vue-router/composables';
import { PaywallPlan, paywallPlanNames } from '@/services/billing-utils';

const props = defineProps({
  plans: { type: Array as PropType<PaywallPlan[]>, required: false, default: () => ['business', 'ultimate'] },
});
const router = useRouter();

const emit = defineEmits(['close']);

const upgradePlanAction = () => {
  router.push('/settings/billing?upgrade=true');
};

const isVIP = computed(() => store.state.settings.account.subStatus === BillingInfoSubscriptionStatus.VIP);

const message = computed(() => paywallPlanNames(props.plans));

</script>
